module.exports = "/365FarmNet/dist/confirm-modal-persistent.66028e1e8250eeff7252ce6bca5320d8.html";